<template>
    <div>
        <span style="color: red;font-weight: bolder;">
            {{ equip.level }}
        </span>
        <span v-if="equip.isJingJian" style="color:fuchsia;font-weight: bolder;">
            精简
        </span>
        <span v-if="equip.maxStrengthLevel > 6" style="color:gold;font-weight: bolder;">
            橙武
        </span>
        <span v-if="equip.skillId != null || equip.allSkillIdList.length > 0" style="color:orange;font-weight: bolder;">
            特效
        </span>
        <span style="color: blue;">
            {{ equip.name }}
        </span>

        <span v-if="equip.damageAddition >= 0" style="color: red;font-weight: bolder;">
            {{ equip.damageAddition }}
        </span>
        <span v-if="equip.damageAddition < 0" style="color: green;font-weight: bolder;">
            {{ equip.damageAddition }}
        </span>
    </div>
</template>


<script>

export default {
    props: {
        equip: {
            level: null,
            name: null,
            damageAddition: null,
            isJingJian: false,
        }
    },
    watch: {
        equip: {
            damageAddition: {
                handler() {
                    this.$forceUpdate();
                }
            },
            handler() {
                this.$forceUpdate();
            }
        }
    },
    methods: {

    },
    onMounted() {
        this.$forceUpdate();
    }

}
</script>


<style lang="less" scoped></style>